<template>
    <InputNumber :value="value"
        :max="max"
        :min="min"
        :precision="precision"
        :formatter="v => number2ThousandsFormat(v, precision, currencyPrefix)"
        :parser="v => thousandsFormat2Number(v, currencyPrefix)"
        :active-change="false"
        :disabled="disabled"
        :readonly="readonly"
        class="number-input"
        @on-change="onChange"
        @on-focus="onFocus"/>
</template>

<script>
import './number.less';
import NumberMixins from './number-mixins';
import { number2ThousandsFormat, thousandsFormat2Number } from '@/components/number-input/display-format';

export default {
    name: 'CurrencyInput',
    mixins: [NumberMixins],
    props: {
        precision: {
            type: Number,
            default: 4
        },
        currencyPrefix: {
            type: String,
            default: '￥'
        },
        max: {
            type: Number,
            default: 10000000
        }
    },
    data() {
        return {};
    },
    methods: {
        thousandsFormat2Number,
        number2ThousandsFormat,
        onFocus(e){
            e.target.select();
        }
    }
};
</script>

<style scoped>

</style>
